import {
  CaseFile,
  CaseMeta,
  CaseRevisionMeta,
  OutcomeResponse,
} from "../pages/cases/types";

export const CaseMockResponse: CaseMeta = {
  id: "99999999-9999-999-9999-999999999999",
  name: "Kapassakis v. Metropolitan Transportation Authority",
  created_at: "2025-01-11T11:17:02.920000+00:00",
  updated_at: "2025-02-09T08:58:19.883712+00:00",
  status: "active",
  status_message: null,
};

export const CasesMockResponse: CaseMeta[] = [CaseMockResponse];

export const OutcomeMockResponse: OutcomeResponse = {
  id: 80,
  information: {
    summary:
      "The plaintiff, Sophie Kapassakis, brought a personal injury action against the defendants following a motor vehicle accident involving a bus operated by the Metropolitan Transportation Authority and driven by Kenold Mathurin. The plaintiff alleges severe injuries, financial hardship, and inability to work due to the accident. Legal proceedings include motions for trial preferences and compensation for past and future pain and suffering.",
    plaintiff: "Sophie Kapassakis",
    defendant:
      "Metropolitan Transportation Authority, Long Island Bus, Metropolitan Bus Authority, Kenold Mathurin, Government Employees Insurance Company",
    place_of_accident: "Nassau County, New York",
    accident_date: "2010-07-26T00:00:00+00:00",
    accident_type: ["vehicle_collision"],
    nature_of_injury: ["knee_injury", "soft_tissue", "neck_injury"],
    compensation: 150000,
    jurisdiction: "Supreme Court, Nassau County, New York",
    insurance_coverage: null,
    policy_limit: null,
    filing_date: "2012-01-01T00:00:00+00:00",
  },
  similar_cases: [
    {
      name: "Chung v. Shaw",
      external_id: "2017-03076",
      summary:
        "Personal injury lawsuit where the plaintiff sought damages after his vehicle was rear-ended by the defendant.",
      jurisdiction: "Queens County, NY",
      similarity_score: 90,
      relevance: {
        "Injury Type": {
          value: 95,
          explanation: "Both involve cervical spine injuries.",
        },
        "Incident Type": {
          value: 90,
          explanation: "Both are motor vehicle accidents.",
        },
        "Injury Severity": {
          value: 85,
          explanation: "Significant injuries requiring surgery in both.",
        },
        "Type of Location": {
          value: 80,
          explanation: "Both occurred in transportation-related areas.",
        },
        "Damages: Pain/Suffering": {
          value: 90,
          explanation: "Similar legal dispute over inadequacy of awards.",
        },
        "Damages: Medical Expenses": {
          value: 70,
          explanation: "Differences in how medical expenses were handled.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 250000.0,
      filing_year: "2013-01-01T00:00:00+00:00",
      time_to_resolution: "3 Years",
    },
    {
      name: "Kelley v. Balasco",
      external_id: "74816-1996",
      summary:
        "Plaintiff individual filed suit against defendant driver to recover for injuries allegedly sustained in an automobile accident.",
      jurisdiction: "Albany County, NY",
      similarity_score: 93,
      relevance: {
        "Injury Type": {
          value: 70,
          explanation:
            "Both cases involve soft tissue injuries resulting from motor vehicle accidents, but Kapassakis involved public transit while Kelley involved a private automobile accident.",
        },
        "Nature of Dispute": {
          value: 90,
          explanation:
            "Both discuss whether the plaintiffs’ injuries met the statutory threshold for 'serious injury' to claim additional damages.",
        },
        "Place of Accident": {
          value: 60,
          explanation:
            "Kapassakis occurred in a public transit context, whereas Kelley occurred on a general roadway.",
        },
        "Severity of Injuries": {
          value: 75,
          explanation:
            "Injuries were contested in both cases as to whether they met the 'serious injury' threshold under New York law.",
        },
        "Proximate Cause of Injury": {
          value: 80,
          explanation:
            "Both cases involved clear proximate cause but with differing defendants: a public entity in Kapassakis and a private individual in Kelley.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 25000.0,
      filing_year: "1996-01-01T00:00:00+00:00",
      time_to_resolution: "4 Years",
    },
    {
      name: "Nichols v. Silverling Motor Grp., Inc.",
      external_id: "713506/2016",
      summary:
        "Plaintiff commenced this action to recover for personal injuries he sustained as a result of a motor vehicle accident.",
      jurisdiction: "New York County, NY",
      similarity_score: 93,
      relevance: {
        "Injury Type": {
          value: 75,
          explanation:
            "Plaintiffs in both cases sought damages for personal injuries from vehicular accidents.",
        },
        "Legal Issues": {
          value: 80,
          explanation:
            "Both address liability and damages from motor vehicle accidents.",
        },
        "Incident Type": {
          value: 90,
          explanation:
            "Both involve motor vehicle accidents leading to personal injury claims.",
        },
        "Outcome Focus": {
          value: 70,
          explanation:
            "Both focus on appropriate compensation for injuries, with Kapassakis addressing adequacy of damages awarded.",
        },
        "Defendant Type": {
          value: 60,
          explanation:
            "Kapassakis involves a public authority; Nichols involves a private company.",
        },
        "Injury Severity": {
          value: 70,
          explanation:
            "Kapassakis details significant injuries; Nichols implies notable harm without specific details.",
        },
        "Type of Location": {
          value: 85,
          explanation:
            "Incidents occurred on public roadways involving organizational vehicles.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 1000000.0,
      filing_year: "2016-01-01T00:00:00+00:00",
      time_to_resolution: "6 Years",
    },
    {
      name: "Hadjidemetriou v. Juarez",
      external_id: "2019-00746",
      summary: "Personal injury lawsuit arising from a motor vehicle accident.",
      jurisdiction: "Queens County, NY",
      similarity_score: 86,
      relevance: {
        "Injury Type": {
          value: 80,
          explanation: "Comparable injuries (e.g., soft-tissue damage).",
        },
        "Incident Type": {
          value: 90,
          explanation: "Both involve vehicular accidents.",
        },
        "Defendant Type": {
          value: 60,
          explanation: "Public authority vs. private party.",
        },
        "Injury Severity": {
          value: 75,
          explanation: "Similar allegations of serious, long-term effects.",
        },
        "Causation Debate": {
          value: 95,
          explanation: "Central issue in both cases, with expert testimony.",
        },
        "Type of Location": {
          value: 70,
          explanation:
            "Both occurred on roadways, but with public vs. private distinction.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 50000.0,
      filing_year: "2014-01-01T00:00:00+00:00",
      time_to_resolution: "6 Years",
    },
    {
      name: "Sagy v. Senft,",
      external_id: "TS-300478-17/QU",
      summary:
        "Plaintiff claimed serious injuries from being struck by the defendants' vehicle in a parking accident.",
      jurisdiction: "Queens County, NY",
      similarity_score: 81,
      relevance: {
        "Injury Type": {
          value: 80,
          explanation:
            "Both involve knee injuries and spinal issues, but Kapassakis includes cervical spine surgeries, while Sagy involves additional lumbar injuries.",
        },
        "Severity of Injuries": {
          value: 60,
          explanation:
            "Kapassakis shows clear surgical interventions, while Sagy has less clarity on causation and severity.",
        },
        "Dispute Over Causation": {
          value: 70,
          explanation:
            "Both cases question the extent to which the accident caused the injuries, though Sagy has more emphasis on pre-existing conditions.",
        },
        "Serious Injury Threshold": {
          value: 50,
          explanation:
            "Both involve the application of Insurance Law § 5102[d], but the categories satisfied differ.",
        },
      },
      resolution_type: "trial",
      case_result: "defendant",
      damages_amount: 420000.0,
      filing_year: "2016-01-01T00:00:00+00:00",
      time_to_resolution: "6 Years",
    },
    {
      name: "Knight v. Barsch",
      external_id: "2015-09141",
      summary:
        "Plaintiff claimed serious injuries resulting from a motor vehicle accident caused by the defendants' negligence.",
      jurisdiction: "Queens County, NY",
      similarity_score: 82,
      relevance: {
        "Injury Type": {
          value: 70,
          explanation:
            "Both mention knee and spinal injuries, but the specific nature, extent, and treatment differ.",
        },
        "Type of Accident": {
          value: 60,
          explanation:
            "Both cases involve motor vehicle accidents. Kapassakis involved a bus accident, while Knight involved a collision with another private vehicle. The general nature of the incidents is similar, but the details (type of vehicles and setting) are different.",
        },
        "Severity of Injury": {
          value: 65,
          explanation:
            "Both cases involved significant injuries, but Kapassakis required surgeries, while Knight involved permanent limitations without evidence of surgery. This creates moderate similarity in terms of injury severity.",
        },
        "Future Pain and Suffering": {
          value: 50,
          explanation:
            "Knight granted a retrial on the issue of future pain and suffering.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 80000.0,
      filing_year: "2012-01-01T00:00:00+00:00",
      time_to_resolution: "5 Years",
    },
    {
      name: "Kelley v. Balasco",
      external_id: "74816",
      summary:
        'The case clarifies that satisfying any one category of "serious injury" under Insurance Law § 5102(d) permits a plaintiff to pursue full damages resulting from an automobile accident. However, the specific amount of damages, including those for future pain and suffering, remains subject to the jury\'s discretion based on the evidence presented.',
      jurisdiction: "Albany County, NY",
      similarity_score: 85,
      relevance: {
        "Injury Type": {
          value: 70,
          explanation:
            "Both cases involve soft tissue injuries resulting from motor vehicle accidents, but Kapassakis involved public transit while Kelley involved a private automobile accident.",
        },
        "Nature of Dispute": {
          value: 90,
          explanation:
            "Both discuss whether the plaintiffs’ injuries met the statutory threshold for 'serious injury' to claim additional damages.",
        },
        "Place of Accident": {
          value: 60,
          explanation:
            "Kapassakis occurred in a public transit context, whereas Kelley occurred on a general roadway.",
        },
        "Severity of Injuries": {
          value: 75,
          explanation:
            "Injuries were contested in both cases as to whether they met the 'serious injury' threshold under New York law.",
        },
        "Proximate Cause of Injury": {
          value: 80,
          explanation:
            "Both cases involved clear proximate cause but with differing defendants: a public entity in Kapassakis and a private individual in Kelley.",
        },
      },
      resolution_type: "trial",
      case_result: "defendant",
      damages_amount: 25000.0,
      filing_year: "1992-01-01T00:00:00+00:00",
      time_to_resolution: "4 Years",
    },
    {
      name: "Cicola v. County of Suffolk",
      external_id: "2012-08236",
      summary:
        "The plaintiff was involved in a motor vehicle accident and subsequently filed a lawsuit against alleging serious injuries.",
      jurisdiction: "Queens County, NY",
      similarity_score: 79,
      relevance: {
        "Injury Type": {
          value: 75,
          explanation:
            "Kapassakis dealt with spinal injuries requiring surgery, while Cicola included other pain and suffering injuries.",
        },
        "Defendant Type": {
          value: 40,
          explanation:
            "Kapassakis involved public transportation, while Cicola involved a county government.",
        },
        "Place of Accident": {
          value: 50,
          explanation:
            "Kapassakis occurred on public transportation, whereas Cicola involved a roadway accident unrelated to public transit.",
        },
        "Time to Resolution": {
          value: 60,
          explanation:
            "Kapassakis took 11 years to resolve, while Cicola resolved in about 4 years.",
        },
        "Severity of Injuries": {
          value: 70,
          explanation:
            "Both cases may involve injuries severe enough to meet the 'serious injury' threshold, but specific impacts differ.",
        },
        "Proximate Cause of Injury": {
          value: 85,
          explanation:
            "Both cases involved vehicular accidents, making causation clear.",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 250000.0,
      filing_year: "2012-01-01T00:00:00+00:00",
      time_to_resolution: "3 Years",
    },
    {
      name: "Sanz v. MTA-Long Is. Bus",
      external_id: "2006-05691",
      summary:
        "Plaintiff, was injured as a passenger on a bus owned by the defendant and, sustained herniated discs in her cervical spine, leading to numbness and tingling in both hands.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 91,
      relevance: {
        "Injury Type": {
          value: 85,
          explanation:
            "Both cases involved spinal injuries requiring surgical intervention.",
        },
        "Defendant Type": {
          value: 100,
          explanation: "Both defendants were public transportation entities.",
        },
        "Time to Resolution": {
          value: 60,
          explanation:
            "Kapassakis took 11 years to resolve, while Sanz resolved in about 5 years.",
        },
        "Severity of Injuries": {
          value: 80,
          explanation:
            "There is a question in both cases about whether injuries are serious enough to meet New York's 'serious injury' threshold.",
        },
        "Proximate Cause of Injury": {
          value: 95,
          explanation:
            "Both cases involved direct collisions between buses, with injuries clearly resulting from the accidents.",
        },
      },
      resolution_type: "trial",
      case_result: "defendant",
      damages_amount: 400000.0,
      filing_year: "2002-01-01T00:00:00+00:00",
      time_to_resolution: "5 Years",
    },
    {
      name: "Michael Brown v. Regional Transit Authority",
      external_id: "56789/2017",
      summary:
        "The plaintiff sued after a transit bus sideswiped his car, alleging back injuries. The defense argued the injuries were not significant and introduced evidence that the plaintiff resumed normal physical activities soon after the accident.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 59,
      relevance: {
        Damages: { value: 65, explanation: "Disputed Injury Severity" },
        "Injury Type": { value: 75, explanation: "Soft-Tissue Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Financial Hardship Claims",
        },
      },
      resolution_type: "trial",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2017-05-20T00:00:00+00:00",
      time_to_resolution: "3 years",
    },
    {
      name: "John Smith v. Metropolitan Transit Service",
      external_id: "67890/2018",
      summary:
        "The plaintiff alleged severe neck and back injuries after a bus failed to stop at a red light and collided with his car. He had pre-existing spinal issues that complicated his case.",
      jurisdiction: "Queens County, NY",
      similarity_score: 69,
      relevance: {
        Damages: { value: 75, explanation: "Disputed Long-Term Damages" },
        "Injury Type": {
          value: 80,
          explanation: "Spinal Injuries with Pre-Existing Conditions",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
        "Financial Hardship": { value: 60, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 150000.0,
      filing_year: "2018-03-10T00:00:00+00:00",
      time_to_resolution: "3 years",
    },
    {
      name: "Anna Lee v. City Transport",
      external_id: "98765/2021",
      summary:
        "The plaintiff suffered minor neck and back injuries when a city bus side-swiped her parked car. She sought damages for medical expenses and lost wages but was found partially at fault for the accident.",
      jurisdiction: "Kings County, NY",
      similarity_score: 61,
      relevance: {
        Fault: { value: 65, explanation: "Partial Fault Assigned" },
        "Injury Type": { value: 70, explanation: "Minor Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Financial Hardship Claims",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2021-06-20T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Emily Carter v. City Transit",
      external_id: "34567/2019",
      summary:
        "The plaintiff claimed neck and back injuries after a bus rear-ended her car at a stoplight. She alleged chronic pain and difficulty working but had a history of minor neck injuries prior to the accident.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 72,
      relevance: {
        "Injury Type": { value: 85, explanation: "Spinal Injuries" },
        "Chronic Pain": { value: 75, explanation: "Alleged" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 90,
          explanation: "Public Transportation Involvement",
        },
        "Pre-Existing Injuries": {
          value: 60,
          explanation: "History of Minor Neck Injuries",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 125000.0,
      filing_year: "2019-09-15T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Gomez v. Salmeron",
      external_id: "014252/12",
      summary:
        'Plaintiff sued after sustaining injuries in a car accident, but the court dismissed her case, finding her injuries did not meet New York\'s "serious injury" threshold.',
      jurisdiction: "Nassau County, NY",
      similarity_score: 70,
      relevance: {
        "Type of Case": {
          value: 90,
          explanation:
            "Both are personal injury lawsuits stemming from motor vehicle accidents.",
        },
        "Type of Injury": {
          value: 65,
          explanation:
            "Both involved spinal and soft tissue injuries, but specifics vary.",
        },
        "Medical Evidence": {
          value: 60,
          explanation:
            "Gomez relied on medical reports of lower quality than Kapassakis.",
        },
        "Role of Plaintiff": {
          value: 60,
          explanation:
            "Kapassakis involved the driver, while Gomez involved a passenger in a taxi.",
        },
        "Nature of Accident": {
          value: 50,
          explanation:
            "Kapassakis involved a rear-end collision; Gomez was a two-vehicle intersection collision.",
        },
        "Severity of Injuries": {
          value: 55,
          explanation:
            "Both plaintiffs claimed significant limitations, but supporting evidence differs.",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2012-01-01T00:00:00+00:00",
      time_to_resolution: "4 Years",
    },
    {
      name: "Lawrence v. Pelkey",
      external_id: "6208/09",
      summary:
        'The defendants sought dismissal of the complaint, arguing that he did not meet the "serious injury" threshold required under New York’s Insurance Law § 5102(d) and the No-Fault Law.',
      jurisdiction: "Columbia County, NY",
      similarity_score: 71,
      relevance: {
        Defendants: {
          value: 70,
          explanation:
            "Kapassakis involved public transit defendants, while Lawrence involved private individuals.",
        },
        "Legal Issue": {
          value: 60,
          explanation:
            "Both address whether the injuries qualify as 'serious' under Insurance Law § 5102(d).",
        },
        "Injury Claims": {
          value: 85,
          explanation:
            "Both plaintiffs claimed serious injuries from the accidents.",
        },
        "Serious Injury": {
          value: 60,
          explanation:
            "In Lawrence, the defendants moved for summary judgment on 'serious injury' grounds.",
        },
        "Experts Opinion": {
          value: 50,
          explanation:
            "In Lawrence, medical experts failed to differentiate between pre-existing and accident-related injuries.",
        },
        "Type of Accident": {
          value: 90,
          explanation:
            "Both involve motor vehicle accidents where the plaintiffs were rear-ended.",
        },
        "Pre-Existing Conditions": {
          value: 50,
          explanation:
            "Defendants in Lawrence highlighted pre-existing conditions to contest causation.",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2009-01-01T00:00:00+00:00",
      time_to_resolution: "1 Year",
    },
    {
      name: "Sarah Green v. Metro Bus Co.",
      external_id: "11223/2018",
      summary:
        "The plaintiff alleged permanent knee and neck injuries after a bus failed to yield and collided with her vehicle. The defense claimed the plaintiff’s damages were exaggerated and unrelated to the accident.",
      jurisdiction: "Queens County, NY",
      similarity_score: 66,
      relevance: {
        Damages: {
          value: 70,
          explanation: "Exaggerated Damage Claims Alleged",
        },
        "Injury Type": { value: 85, explanation: "Permanent Injuries Claimed" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 90,
          explanation: "Public Transportation Involvement",
        },
        "Financial Hardship": {
          value: 60,
          explanation: "Moderate Financial Hardship",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 145000.0,
      filing_year: "2018-01-10T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "James Wilson v. Urban Transit",
      external_id: "43210/2020",
      summary:
        "The plaintiff filed suit for minor neck and back injuries after a bus allegedly made an illegal turn and struck his car. The case was dismissed due to insufficient evidence proving the bus driver’s negligence.",
      jurisdiction: "Kings County, NY",
      similarity_score: 49,
      relevance: {
        Disability: {
          value: 45,
          explanation: "No Long-Term Disability Claimed",
        },
        "Injury Type": { value: 70, explanation: "Minor Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
        "Negligence Evidence": {
          value: 50,
          explanation: "Weak Negligence Evidence",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-06-12T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Olivia Harris v. Metro Transit",
      external_id: "99887/2016",
      summary:
        "The plaintiff claimed severe neck and back injuries requiring surgery after a bus collided with her car. The defense argued the plaintiff’s injuries were primarily due to a prior car accident five years earlier.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 54,
      relevance: {
        Treatment: { value: 75, explanation: "Surgery Required" },
        Disability: { value: 60, explanation: "Long-Term Disability Disputed" },
        "Injury Type": {
          value: 80,
          explanation: "Spinal Injuries with Pre-Existing Conditions",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 50000.0,
      filing_year: "2016-03-25T00:00:00+00:00",
      time_to_resolution: "3 years",
    },
    {
      name: "Laura Thomas v. Public Transport",
      external_id: "33445/2021",
      summary:
        "The plaintiff filed a lawsuit after suffering minor injuries in a bus collision. The defense successfully argued that the plaintiff’s claims were frivolous and unsupported by medical evidence.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 44,
      relevance: {
        "Injury Type": { value: 70, explanation: "Minor Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Public Transportation Involvement",
        },
        "Medical Evidence": { value: 50, explanation: "Lack of Medical Proof" },
        "Financial Hardship": {
          value: 40,
          explanation: "No Financial Hardship Claimed",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2021-11-05T00:00:00+00:00",
      time_to_resolution: "1 year",
    },
    {
      name: "David Johnson v. Private Driver",
      external_id: "77654/2018",
      summary:
        "The plaintiff alleged neck and back injuries requiring surgery after a distracted driver rear-ended his car at a red light. The defense argued that the injuries were exaggerated and partially caused by prior incidents.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 72,
      relevance: {
        Damages: { value: 75, explanation: "Disputed Injury Severity" },
        "Injury Type": {
          value: 85,
          explanation: "Spinal Injuries Requiring Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Financial Hardship": { value: 50, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 90000.0,
      filing_year: "2018-05-20T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Emma Lopez v. Delivery Driver",
      external_id: "55312/2019",
      summary:
        "The plaintiff suffered knee and back injuries when a delivery van struck her car while merging onto the highway. The defense claimed the plaintiff failed to prove the driver was negligent and suggested comparative negligence.",
      jurisdiction: "Queens County, NY",
      similarity_score: 65,
      relevance: {
        Fault: { value: 70, explanation: "Disputed Negligence" },
        Disability: {
          value: 55,
          explanation: "No Long-Term Disability Claimed",
        },
        "Injury Type": { value: 80, explanation: "Knee and Back Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Financial Hardship": { value: 60, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 85000.0,
      filing_year: "2019-03-15T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Olivia Martinez v. Rideshare Co.",
      external_id: "22345/2020",
      summary:
        "The plaintiff alleged neck and shoulder injuries after being involved in a car crash while riding in a rideshare vehicle. She claimed limited work capacity and ongoing pain.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 62,
      relevance: {
        "Injury Type": { value: 80, explanation: "Neck and Shoulder Injuries" },
        "Chronic Pain": { value: 65, explanation: "Long-Term Pain Alleged" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 85, explanation: "Rideshare Involvement" },
        "Financial Hardship": { value: 50, explanation: "Not Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 60000.0,
      filing_year: "2020-02-10T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Mike Adams v. Corporate Fleet",
      external_id: "66544/2017",
      summary:
        "The plaintiff suffered a herniated disc after a collision with a corporate fleet vehicle. The defense claimed the collision was unavoidable due to icy road conditions and sought dismissal.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 57,
      relevance: {
        "Injury Type": {
          value: 75,
          explanation: "Spinal Injury Without Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Corporate Fleet Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Significant Financial Hardship",
        },
        "Environmental Factors": {
          value: 70,
          explanation: "Collision Due to Icy Road Conditions",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2017-01-05T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Laura King v. Utility Company",
      external_id: "90987/2019",
      summary:
        "The plaintiff sued for injuries sustained when a utility truck struck her car while exiting a parking lot. She claimed significant back pain and inability to work, but the defense argued she failed to follow proper traffic laws.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 64,
      relevance: {
        Fault: { value: 75, explanation: "Comparative Negligence Claimed" },
        "Injury Type": {
          value: 85,
          explanation: "Back Injuries Without Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Utility Company Involvement",
        },
        "Financial Hardship": {
          value: 65,
          explanation: "Moderate Financial Hardship Alleged",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 75000.0,
      filing_year: "2019-06-18T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Rachel Brown v. Construction Co.",
      external_id: "88855/2020",
      summary:
        "The plaintiff claimed serious knee injuries after her vehicle collided with a construction vehicle blocking a lane without proper signage. The defense argued the plaintiff was speeding at the time of the accident.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 60,
      relevance: {
        Fault: { value: 70, explanation: "Partial Negligence Alleged" },
        "Injury Type": {
          value: 85,
          explanation: "Knee Injury Requiring Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Construction Vehicle Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Financial Hardship Claimed",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 105000.0,
      filing_year: "2020-11-10T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Chris Turner v. Truck Driver",
      external_id: "44432/2018",
      summary:
        "The plaintiff suffered neck injuries in a collision with a commercial truck. The court dismissed the case after finding insufficient evidence of negligence by the truck driver.",
      jurisdiction: "Kings County, NY",
      similarity_score: 51,
      relevance: {
        Fault: { value: 65, explanation: "Weak Negligence Evidence" },
        Disability: {
          value: 50,
          explanation: "No Long-Term Disability Claimed",
        },
        "Injury Type": { value: 70, explanation: "Minor Neck Injury" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 75,
          explanation: "Commercial Truck Involvement",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2018-04-15T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Sarah Klein v. Parking Garage Co.",
      external_id: "33221/2021",
      summary:
        "The plaintiff claimed neck and back injuries after a parking garage vehicle reversed into her car. The defense argued that the plaintiff was partially at fault for driving in an unauthorized area of the garage.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 56,
      relevance: {
        Fault: { value: 70, explanation: "Comparative Negligence Alleged" },
        "Injury Type": {
          value: 75,
          explanation: "Minor Back and Neck Injuries",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 80, explanation: "Parking Garage Incident" },
        "Financial Hardship": { value: 50, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 50000.0,
      filing_year: "2021-01-20T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Daniel White v. Driver",
      external_id: "67654/2019",
      summary:
        "The plaintiff alleged serious spinal injuries requiring surgery after being hit by a drunk driver. The defense challenged the severity of injuries, arguing they were exaggerated and partially pre-existing.",
      jurisdiction: "Queens County, NY",
      similarity_score: 69,
      relevance: {
        Damages: { value: 75, explanation: "Disputed Long-Term Impact" },
        "Injury Type": {
          value: 85,
          explanation: "Spinal Injuries Requiring Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Drunk Driver Involvement",
        },
        "Financial Hardship": {
          value: 65,
          explanation: "Limited Financial Hardship Alleged",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 200000.0,
      filing_year: "2019-09-15T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Angela Davis v. Logistics Truck",
      external_id: "11099/2020",
      summary:
        "The plaintiff claimed significant knee and back injuries after a logistics truck failed to stop at a crosswalk and struck her vehicle. The case was dismissed due to insufficient evidence of negligence.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 58,
      relevance: {
        Fault: { value: 65, explanation: "Weak Evidence of Negligence" },
        "Injury Type": { value: 75, explanation: "Knee and Back Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Commercial Truck Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Financial Hardship Claimed",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-07-10T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Lisa Harper v. Private Driver",
      external_id: "99234/2017",
      summary:
        "The plaintiff suffered neck injuries and claimed emotional distress after being sideswiped by a speeding car. The defense argued there was no clear evidence that the defendant caused the accident.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 61,
      relevance: {
        Disability: { value: 50, explanation: "No Long-Term Disability" },
        "Injury Type": { value: 70, explanation: "Minor Neck Injury" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 75, explanation: "Disputed Fault" },
        "Emotional Distress": {
          value: 65,
          explanation: "Emotional Distress Claimed",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 40000.0,
      filing_year: "2017-08-12T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Kevin Sanders v. Logistics Driver",
      external_id: "33777/2018",
      summary:
        "The plaintiff alleged severe back injuries requiring surgery after a collision with a delivery truck. The defense presented evidence suggesting the plaintiff had a history of back problems and partially blamed icy conditions.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 64,
      relevance: {
        Fault: { value: 70, explanation: "Pre-Existing Conditions Claimed" },
        "Injury Type": {
          value: 85,
          explanation: "Spinal Injuries Requiring Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Commercial Vehicle Involvement",
        },
        "Environmental Factors": {
          value: 60,
          explanation: "Icy Conditions Blamed",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 95000.0,
      filing_year: "2018-06-15T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Megan Wells v. Trucking Company",
      external_id: "22345/2019",
      summary:
        "The plaintiff sued for neck and knee injuries after a trucking company’s vehicle collided with hers at an intersection. The defense argued that poor visibility and unclear signage were mitigating factors.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 62,
      relevance: {
        Fault: { value: 65, explanation: "Disputed Negligence" },
        "Injury Type": { value: 75, explanation: "Knee and Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Commercial Truck Involvement",
        },
        "Financial Hardship": { value: 50, explanation: "Not Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 80000.0,
      filing_year: "2019-04-10T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Ashley Ford v. Teen Driver",
      external_id: "88112/2020",
      summary:
        "The plaintiff filed suit for back injuries after being rear-ended by a teen driver in a parking lot. The case was dismissed as the court found no evidence that the injuries were serious under New York's no-fault threshold.",
      jurisdiction: "Queens County, NY",
      similarity_score: 57,
      relevance: {
        Fault: { value: 65, explanation: "Weak Injury Evidence" },
        Disability: {
          value: 50,
          explanation: "No Significant Long-Term Disability",
        },
        "Injury Type": { value: 70, explanation: "Minor Back Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 75, explanation: "Teen Driver Involvement" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-02-25T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Robert Hill v. Ride-Hailing Service",
      external_id: "45109/2018",
      summary:
        "The plaintiff claimed neck and back injuries after a collision with a ride-hailing service vehicle. The defense successfully argued that the plaintiff failed to seek medical treatment promptly after the accident.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 54,
      relevance: {
        Fault: { value: 65, explanation: "Delayed Medical Treatment Alleged" },
        "Injury Type": {
          value: 70,
          explanation: "Minor Neck and Back Injuries",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Ride-Hailing Involvement",
        },
        "Financial Hardship": {
          value: 50,
          explanation: "No Financial Hardship Claimed",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2018-03-01T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Grace Miller v. Food Delivery Co.",
      external_id: "33990/2019",
      summary:
        "The plaintiff suffered knee injuries requiring surgery after a food delivery van hit her while she was crossing at a marked crosswalk. The defense argued she was partially responsible for not paying attention.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 67,
      relevance: {
        Fault: { value: 70, explanation: "Comparative Negligence Alleged" },
        "Injury Type": {
          value: 85,
          explanation: "Knee Injury Requiring Surgery",
        },
        "Incident Type": { value: 85, explanation: "Pedestrian Accident" },
        "Defendant Type": {
          value: 80,
          explanation: "Commercial Vehicle Involvement",
        },
        "Financial Hardship": { value: 60, explanation: "Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 120000.0,
      filing_year: "2019-07-01T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Emily Shaw v. Drunk Driver",
      external_id: "99432/2017",
      summary:
        "The plaintiff suffered neck injuries after a collision with a drunk driver. The defense argued that the plaintiff’s injuries were minor and did not warrant significant compensation.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 59,
      relevance: {
        Fault: { value: 65, explanation: "Long-Term Impact Disputed" },
        "Injury Type": { value: 75, explanation: "Minor Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Drunk Driver Involvement",
        },
        "Financial Hardship": { value: 50, explanation: "Not Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 60000.0,
      filing_year: "2017-05-20T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Jack Porter v. Employer Vehicle",
      external_id: "66123/2018",
      summary:
        "The plaintiff alleged back injuries after a company car rear-ended his vehicle. The defense argued that the injuries were not caused by the accident and presented evidence of a prior work injury.",
      jurisdiction: "Queens County, NY",
      similarity_score: 63,
      relevance: {
        Fault: { value: 70, explanation: "Pre-Existing Conditions Claimed" },
        "Injury Type": {
          value: 80,
          explanation: "Back Injuries Without Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Employer Vehicle Involvement",
        },
        "Financial Hardship": { value: 55, explanation: "Not Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 85000.0,
      filing_year: "2018-03-10T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Linda Harris v. Motorcycle Rider",
      external_id: "55671/2020",
      summary:
        "The plaintiff claimed knee and neck injuries after a motorcycle rider collided with her car at a stop sign. The defense argued that the plaintiff had sufficient time to avoid the collision.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 56,
      relevance: {
        Fault: { value: 70, explanation: "Disputed Fault" },
        "Injury Type": { value: 75, explanation: "Knee and Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 80, explanation: "Motorcycle Involvement" },
        "Financial Hardship": { value: 20, explanation: "Not Claimed" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-11-15T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Rachel Carter v. Driver in Rental Car",
      external_id: "88776/2019",
      summary:
        "The plaintiff suffered minor back injuries after being hit by a driver in a rental car. The defense argued the driver was following all traffic laws and was not at fault.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 52,
      relevance: {
        Fault: { value: 65, explanation: "Weak Negligence Evidence" },
        "Injury Type": { value: 70, explanation: "Minor Back Injury" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 80, explanation: "Rental Car Involvement" },
        "Financial Hardship": { value: 50, explanation: "Not Claimed" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2019-04-01T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Amanda Jones v. Taxi Driver",
      external_id: "99912/2021",
      summary:
        "The plaintiff alleged neck injuries and emotional distress after a taxi collided with her vehicle at an intersection. The defense argued that the plaintiff failed to stop at a stop sign, contributing to the accident.",
      jurisdiction: "Queens County, NY",
      similarity_score: 58,
      relevance: {
        Fault: { value: 70, explanation: "Disputed Fault" },
        "Injury Type": { value: 70, explanation: "Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": { value: 85, explanation: "Taxi Involvement" },
        "Emotional Distress": { value: 65, explanation: "Alleged" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 55000.0,
      filing_year: "2021-03-15T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Matthew Cole v. Construction Firm",
      external_id: "55987/2019",
      summary:
        "The plaintiff suffered a herniated disc after a construction truck sideswiped his vehicle. The defense successfully argued that poor lighting and shared responsibility caused the collision.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 64,
      relevance: {
        "Injury Type": {
          value: 80,
          explanation: "Spinal Injuries Without Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Construction Truck Involvement",
        },
        "Financial Hardship": {
          value: 60,
          explanation: "Limited Financial Hardship",
        },
        "Environmental Factors": {
          value: 70,
          explanation: "Poor Lighting and Shared Responsibility",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2019-06-20T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Stephanie Reed v. Delivery Driver",
      external_id: "11234/2020",
      summary:
        "The plaintiff claimed back and knee injuries after being hit by a delivery van. The defense argued that the accident caused only minor injuries and the plaintiff exaggerated her claims.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 61,
      relevance: {
        Fault: { value: 70, explanation: "Injury Severity Disputed" },
        "Injury Type": { value: 80, explanation: "Back and Knee Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Delivery Vehicle Involvement",
        },
        "Financial Hardship": { value: 55, explanation: "Not Proven" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 45000.0,
      filing_year: "2020-01-10T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "John Taylor v. Drunk Driver",
      external_id: "66589/2018",
      summary:
        "The plaintiff alleged severe neck injuries and loss of mobility after being rear-ended by a drunk driver. The defense argued that the plaintiff's injuries were primarily due to pre-existing conditions.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 69,
      relevance: {
        Fault: { value: 75, explanation: "Pre-Existing Conditions Claimed" },
        "Injury Type": { value: 85, explanation: "Severe Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Drunk Driver Involvement",
        },
        "Financial Hardship": { value: 65, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 150000.0,
      filing_year: "2018-05-05T00:00:00+00:00",
      time_to_resolution: "2.5 years",
    },
    {
      name: "Alice Cooper v. Utility Company",
      external_id: "44789/2019",
      summary:
        "The plaintiff claimed serious spinal injuries after her vehicle collided with a utility truck parked in a no-parking zone. The defense argued the plaintiff was speeding and not paying attention to the road.",
      jurisdiction: "Nassau County, NY",
      similarity_score: 66,
      relevance: {
        Fault: { value: 75, explanation: "Comparative Negligence Alleged" },
        "Injury Type": {
          value: 85,
          explanation: "Spinal Injuries Requiring Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Utility Truck Involvement",
        },
        "Financial Hardship": {
          value: 60,
          explanation: "Moderate Financial Hardship Claimed",
        },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 125000.0,
      filing_year: "2019-02-15T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Olivia White v. Local Contractor",
      external_id: "77345/2020",
      summary:
        "The plaintiff suffered knee and neck injuries after a contractor's truck backed into her car in a parking lot. The defense claimed the plaintiff was speeding and had enough time to avoid the collision.",
      jurisdiction: "Bronx County, NY",
      similarity_score: 60,
      relevance: {
        Fault: { value: 70, explanation: "Disputed Fault" },
        "Injury Type": { value: 80, explanation: "Knee and Neck Injuries" },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Contractor Vehicle Involvement",
        },
        "Financial Hardship": { value: 55, explanation: "Not Claimed" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-01-20T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Brian Wilson v. Food Delivery Co.",
      external_id: "22998/2021",
      summary:
        "The plaintiff claimed serious knee injuries after being hit by a food delivery scooter while walking in a crosswalk. The defense argued that the plaintiff was jaywalking and inattentive.",
      jurisdiction: "Manhattan, NY",
      similarity_score: 63,
      relevance: {
        Fault: { value: 70, explanation: "Disputed Fault" },
        "Injury Type": {
          value: 85,
          explanation: "Knee Injury Requiring Surgery",
        },
        "Incident Type": { value: 85, explanation: "Pedestrian Accident" },
        "Defendant Type": { value: 80, explanation: "Scooter Involvement" },
        "Financial Hardship": { value: 60, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 80000.0,
      filing_year: "2021-05-15T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Laura Bennett v. Corporate Driver",
      external_id: "33998/2018",
      summary:
        "The plaintiff suffered minor back and neck injuries in a collision with a corporate vehicle. The defense argued the accident was unavoidable due to bad weather conditions.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 57,
      relevance: {
        Fault: { value: 70, explanation: "Environmental Defense" },
        "Injury Type": {
          value: 75,
          explanation: "Minor Back and Neck Injuries",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 80,
          explanation: "Corporate Vehicle Involvement",
        },
        "Financial Hardship": { value: 55, explanation: "Not Claimed" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2018-03-10T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Megan Clark v. Rideshare Driver",
      external_id: "55671/2019",
      summary:
        "The plaintiff alleged severe spinal injuries after a collision with a rideshare vehicle. The defense argued that the plaintiff's claims were exaggerated and inconsistent with the damage to her car.",
      jurisdiction: "Queens County, NY",
      similarity_score: 65,
      relevance: {
        Fault: { value: 75, explanation: "Exaggerated Claims Alleged" },
        "Injury Type": {
          value: 80,
          explanation: "Spinal Injuries Without Surgery",
        },
        "Incident Type": { value: 90, explanation: "Vehicle Collision" },
        "Defendant Type": {
          value: 85,
          explanation: "Rideshare Vehicle Involvement",
        },
        "Financial Hardship": { value: 60, explanation: "Not Claimed" },
      },
      resolution_type: "trial",
      case_result: "plaintiff",
      damages_amount: 70000.0,
      filing_year: "2019-04-15T00:00:00+00:00",
      time_to_resolution: "2 years",
    },
    {
      name: "Adam Stone v. Bicyclist",
      external_id: "77823/2020",
      summary:
        "The plaintiff filed a lawsuit for knee injuries after a bicyclist hit his parked car, causing him to fall while getting out. The defense successfully argued the plaintiff was not using caution when exiting.",
      jurisdiction: "Staten Island, NY",
      similarity_score: 56,
      relevance: {
        Disability: { value: 65, explanation: "No Long-Term Disability" },
        "Injury Type": { value: 75, explanation: "Knee Injury" },
        "Incident Type": { value: 85, explanation: "Bicycle Accident" },
        "Defendant Type": { value: 80, explanation: "Disputed Fault" },
        "Financial Hardship": { value: 50, explanation: "Not Claimed" },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2020-06-10T00:00:00+00:00",
      time_to_resolution: "1.5 years",
    },
    {
      name: "Shockley v. Gonzalez-Castillion",
      external_id: "EF007545/2018",
      summary:
        "Plaintiff sought damages for alleged personal injuries from a three-car accident but failed to establish serious injury causally related to the accident.",
      jurisdiction: "Orange County, NY",
      similarity_score: 74,
      relevance: {
        "Injury Types": {
          value: 75,
          explanation:
            "Both plaintiffs claimed injuries to the cervical spine.",
        },
        "Accident Type": {
          value: 80,
          explanation: "Both cases involve motor vehicle accidents.",
        },
        "Place of Accident": {
          value: 60,
          explanation:
            "Both occurred on public roads, but specific locations differ.",
        },
        "Causation Disputes": {
          value: 85,
          explanation:
            "Causation was disputed in both cases, relying on medical testimony.",
        },
        "Negligence Factors": {
          value: 50,
          explanation:
            "Negligence was argued in Shockley, including shared fault due to icy conditions.",
        },
        "Weather Conditions": {
          value: 30,
          explanation:
            "Weather was not significant in Kapassakis but was central in Shockley.",
        },
        "Pre-existing Conditions": {
          value: 70,
          explanation: "Pre-existing conditions were only argued in Shockley.",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2016-01-01T00:00:00+00:00",
      time_to_resolution: "4 Years",
    },
    {
      name: "Vera v. O'Connor",
      external_id: "605876/16",
      summary:
        'The court dismissed plaintiff personal injury lawsuit, finding she failed to prove a "serious injury" under New York Insurance Law § 5102(d) following a 2015 car accident.',
      jurisdiction: "Nassau County, NY",
      similarity_score: 77,
      relevance: {
        "Injury Type": {
          value: 30,
          explanation:
            "In Kapassakis, the plaintiff suffered knee injuries and cervical spine injuries requiring surgeries. In Vera, the plaintiff’s primary injury was a puncture wound to the right breast, along with soft tissue injuries and minor musculoskeletal issues. The injuries differ substantially in nature and severity.",
        },
        "Type of Accident": {
          value: 40,
          explanation:
            "Both cases involve automobile accidents. In Kapassakis, the accident involved a collision with a Metropolitan Transportation Authority bus, while in Vera, the accident involved two private vehicles.",
        },
        "Severity of Injury": {
          value: 20,
          explanation:
            "The injuries in Kapassakis were more severe, involving surgeries. In Vera, the injuries were relatively minor, resolving with antibiotics and minimal medical intervention. This significant difference in injury severity reduces similarity.",
        },
        "Medical Documentation": {
          value: 60,
          explanation:
            "In Kapassakis, the medical evidence included surgery records, while in Vera, the evidence was primarily from a short-term post-accident period. The reliance on medical records provides some similarity, albeit with differing scopes.",
        },
      },
      resolution_type: "dismissal",
      case_result: "defendant",
      damages_amount: 0.0,
      filing_year: "2016-01-01T00:00:00+00:00",
      time_to_resolution: "2 Years",
    },
  ],
  predictions: {
    resolution_likelihood: {
      settlement: {
        probability_percent: 70,
        confidence_interval: { min: 66, max: 74 },
        explanation: "Simulations show the likelihood falls between 66-74% in 95 out of 100 scenarios, based on similar cases and your case specifics.",
      },
      trial: {
        probability_percent: 25,
        confidence_interval: { min: 22, max: 28 },
        explanation: "Simulations show the likelihood falls between 22-28% in 95 out of 100 scenarios, based on similar cases and your case specifics.",
      },
      dismissal: {
        probability_percent: 5,
        confidence_interval: { min: 3, max: 7 },
        explanation: "Simulations show the likelihood falls between 3-7% in 95 out of 100 scenarios, based on similar cases and your case specifics.",
      },
    },
    settlement_damages: {
      explanation: "",
      min: 75000.0,
      max: 250000.0,
      data_points: [[0.0, 6.758100000000001], [5051.0, 7.9695], [10101.0, 9.349300000000001], [15152.0, 10.9111], [20202.0, 12.667700000000002],
                    [25253.0, 14.6307], [30303.0, 16.8101], [35354.0, 19.2139], [40404.0, 21.8475], [45455.0, 24.712999999999997], [50505.0, 27.8092],
                    [55556.0, 31.130799999999997], [60606.0, 34.6682], [65657.0, 38.4072], [70707.0, 42.328500000000005],
                    [75758.0, 46.407900000000005], [80808.0, 50.6163], [85859.0, 54.919700000000006], [90909.0, 59.2795], [95960.0, 63.6533], [101010.0, 67.9949],
                    [106061.0, 72.2555], [111111.0, 76.3844], [116162.0, 80.33], [121212.0, 84.0408], [126263.0, 87.4664], [131313.0, 90.5591], [136364.0, 93.2743], [141414.0, 95.5721],
                    [146465.0, 97.4181], [151515.0, 98.7841], [156566.0, 99.64920000000001], [161616.0, 100.0], [166667.0, 99.831], [171717.0, 99.1447], [176768.0, 97.952],
                    [181818.0, 96.27120000000001], [186869.0, 94.1279], [191919.0, 91.5545], [196970.0, 88.5891], [202020.0, 85.27470000000001], [207071.0, 81.6581],
                    [212121.0, 77.78890000000001], [217172.0, 73.7182], [222222.0, 69.4979], [227273.0, 65.179], [232323.0, 60.811099999999996], [237374.0, 56.441300000000005],
                    [242424.0, 52.1135], [247475.0, 47.8678], [252525.0, 43.7397], [257576.0, 39.76], [262626.0, 35.9548], [267677.0, 32.345], [272727.0, 28.946499999999997],
                    [277778.0, 25.770599999999998], [282828.0, 22.823999999999998], [287879.0, 20.1093], [292929.0, 17.6256], [297980.0, 15.3684], [303030.0, 13.3307],
                    [308081.0, 11.5031], [313131.0, 9.874600000000001], [318182.0, 8.432599999999999], [323232.0, 7.163799999999999], [328283.0, 6.0543], [333333.0, 5.0901000000000005],
                    [338384.0, 4.2572], [343434.0, 3.5421], [348485.0, 2.9318], [353535.0, 2.4141], [358586.0, 1.9775], [363636.0, 1.6114], [368687.0, 1.3063], [373737.0, 1.0534],
                    [378788.0, 0.8451], [383838.0, 0.6745], [388889.0, 0.5355000000000001], [393939.0, 0.42300000000000004], [398990.0, 0.3323], [404040.0, 0.25980000000000003],
                    [409091.0, 0.202], [414141.0, 0.1562], [419192.0, 0.1202], [424242.0, 0.092], [429293.0, 0.0701], [434343.0, 0.0531], [439394.0, 0.04], [444444.0, 0.03],
                    [449495.0, 0.0224], [454545.0, 0.0166], [459596.0, 0.0123], [464646.0, 0.009000000000000001], [469697.0, 0.006600000000000001], [474747.0, 0.0048000000000000004],
                    [479798.0, 0.0034999999999999996], [484848.0, 0.0025], [489899.0, 0.0018], [494949.0, 0.0013], [500000.0, 0.0009]],
      economic: null,
      non_economic: null,
    },
    trial_damages: {
      explanation: "",
      min: 75000.0,
      max: 250000.0,
      data_points:  [[0.0, 6.758100000000001], [5051.0, 7.9695], [10101.0, 9.349300000000001], [15152.0, 10.9111], [20202.0, 12.667700000000002],
                    [25253.0, 14.6307], [30303.0, 16.8101], [35354.0, 19.2139], [40404.0, 21.8475], [45455.0, 24.712999999999997], [50505.0, 27.8092],
                    [55556.0, 31.130799999999997], [60606.0, 34.6682], [65657.0, 38.4072], [70707.0, 42.328500000000005],
                    [75758.0, 46.407900000000005], [80808.0, 50.6163], [85859.0, 54.919700000000006], [90909.0, 59.2795], [95960.0, 63.6533], [101010.0, 67.9949],
                    [106061.0, 72.2555], [111111.0, 76.3844], [116162.0, 80.33], [121212.0, 84.0408], [126263.0, 87.4664], [131313.0, 90.5591], [136364.0, 93.2743], [141414.0, 95.5721],
                    [146465.0, 97.4181], [151515.0, 98.7841], [156566.0, 99.64920000000001], [161616.0, 100.0], [166667.0, 99.831], [171717.0, 99.1447], [176768.0, 97.952],
                    [181818.0, 96.27120000000001], [186869.0, 94.1279], [191919.0, 91.5545], [196970.0, 88.5891], [202020.0, 85.27470000000001], [207071.0, 81.6581],
                    [212121.0, 77.78890000000001], [217172.0, 73.7182], [222222.0, 69.4979], [227273.0, 65.179], [232323.0, 60.811099999999996], [237374.0, 56.441300000000005],
                    [242424.0, 52.1135], [247475.0, 47.8678], [252525.0, 43.7397], [257576.0, 39.76], [262626.0, 35.9548], [267677.0, 32.345], [272727.0, 28.946499999999997],
                    [277778.0, 25.770599999999998], [282828.0, 22.823999999999998], [287879.0, 20.1093], [292929.0, 17.6256], [297980.0, 15.3684], [303030.0, 13.3307],
                    [308081.0, 11.5031], [313131.0, 9.874600000000001], [318182.0, 8.432599999999999], [323232.0, 7.163799999999999], [328283.0, 6.0543], [333333.0, 5.0901000000000005],
                    [338384.0, 4.2572], [343434.0, 3.5421], [348485.0, 2.9318], [353535.0, 2.4141], [358586.0, 1.9775], [363636.0, 1.6114], [368687.0, 1.3063], [373737.0, 1.0534],
                    [378788.0, 0.8451], [383838.0, 0.6745], [388889.0, 0.5355000000000001], [393939.0, 0.42300000000000004], [398990.0, 0.3323], [404040.0, 0.25980000000000003],
                    [409091.0, 0.202], [414141.0, 0.1562], [419192.0, 0.1202], [424242.0, 0.092], [429293.0, 0.0701], [434343.0, 0.0531], [439394.0, 0.04], [444444.0, 0.03],
                    [449495.0, 0.0224], [454545.0, 0.0166], [459596.0, 0.0123], [464646.0, 0.009000000000000001], [469697.0, 0.006600000000000001], [474747.0, 0.0048000000000000004],
                    [479798.0, 0.0034999999999999996], [484848.0, 0.0025], [489899.0, 0.0018], [494949.0, 0.0013], [500000.0, 0.0009]],
      economic: 87000.0,
      non_economic: 75500.0,
    },
    party_favored: {
      plaintiff: {
        probability_percent: 77,
        confidence_interval: { min: 75, max: 79 },
        explanation: "Simulations show the likelihood falls between 75-79% in 95 out of 100 scenarios, based on similar cases and your case specifics.",
      },
      defendant: {
        probability_percent: 23,
        confidence_interval: { min: 21, max: 25 },
        explanation: "Simulations show the likelihood falls between 21-25% in 95 out of 100 scenarios, based on similar cases and your case specifics.",
      },
    },
    liability: {
      probability_percent: 89,
      confidence_interval: null,
      explanation: {
        "High Duty of Care":
          'Public transportation entities, like the MTA, are held to a higher standard of care as "common carriers." If the bus driver’s negligence contributed to the accident, liability is likely to fall heavily on the employer through vicarious liability.',
        "Evidence of Negligence":
          "Accident evidence such as police reports, witness testimony, or onboard cameras can strongly support the plaintiff's claims. Defenses like comparative negligence or unavoidable circumstances are less likely to fully absolve liability.",
      },
    },
    fees: null,
    verdict: {
      most_likely: null,
      best_case_plaintiff: null,
      best_case_defendant: null,
    },
  },
};

export const RevisionMockResponse: CaseRevisionMeta = {
  id: 80,
  created_at: "2025-01-24T11:22:40.000896+00:00",
  description: "Uploaded files: detailed_intake_form.pdf, medical_records.pdf",
  is_impact: true,
  revised_by: "user",
  status: "ready",
  status_message: null,
};

export const FilesMockResponse: CaseFile[] = [
  {
    id: 1,
    filename: "medical_records.pdf",
    path: "medical_records.pdf",
    uploaded_at: new Date().toISOString(),
  },
  {
    id: 2,
    filename: "detailed_intake_form.pdf",
    path: "detailed_intake_form.pdf",
    uploaded_at: new Date().toISOString(),
  }
];

export const RevisionsMockResponse: CaseRevisionMeta[] = [
  {
    id: 1,
    created_at: "2024-02-18T10:00:00Z",
    status: "ready",
    description: "Uploaded files: detailed_intake_form.pdf, medical_records.pdf",
    is_impact: true,
    revised_by: "Yariv Lissauer",
    status_message: null,
  },
  {
    id: 2,
    created_at: "2024-02-18T10:00:00Z",
    status: "ready",
    description: "New precedent add to system, models have been updated.",
    is_impact: true,
    revised_by: "System",
    status_message: null,
  },
  {
    id: 3,
    created_at: "2024-02-18T10:00:00Z",
    status: "processing_documents",
    description: "Uploaded file: medical_records2.pdf",
    is_impact: true,
    revised_by: "Yariv Lissauer",
    status_message: null,
  },
];